import { ClassificationNodeId } from '@/interfaces/Classification.interface';
import { DashboardingProvider } from '@/providers/dashboarding.provider';
import { UiButtonComponent } from '@/ui/button/ui-button';
import { isNotNullish } from '@/utils/typing/is-nullish.predicate';
import { Component, EventEmitter, inject, Output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ClassificationNodeSelectorV2Component } from '../../../classification-node-selector-v2/classification-node-selector-v2';
import type { ClassificationNodeLight } from '../../../classification-node-selector-v2/modal/favorite-perimeter.interface';
import { FavoritePerimeterService } from '../../../classification-node-selector-v2/modal/service/favorite-perimeter.service';

@Component({
    selector: 'main-classification-node-selector',
    templateUrl: './main-classification-node-selector.component.html',
    styleUrls: ['./main-classification-node-selector.component.scss'],
    imports: [ClassificationNodeSelectorV2Component, UiButtonComponent, TranslatePipe]
})
export class MainClassificationNodeSelectorComponent {
    private _dashboardingProvider = inject(DashboardingProvider);
    private _favoritePerimeterService = inject(FavoritePerimeterService);

    pickedClassificationNodeLight: ClassificationNodeLight | null = null;

    @Output() close: EventEmitter<void> = new EventEmitter();

    validate() {
        if (!this.pickedClassificationNodeLight) {
            return;
        }
        this._dashboardingProvider.setSelectedNodeId(this.pickedClassificationNodeLight.classificationNodeId).then(() => {
            this.close.emit();
        });
    }

    changeClassificationFromSelectedFavoriteClassification(classificationNodeId: ClassificationNodeId) {
        this._dashboardingProvider.setSelectedNodeId(classificationNodeId).then(() => {
            this.close.emit();
        });
    }

    savePerimeter() {
        if (
            isNotNullish(this.pickedClassificationNodeLight) &&
            this.pickedClassificationNodeLight.classificationNodeId !== ClassificationNodeId.ALL_BUILDINGS_NODE
        ) {
            this._favoritePerimeterService.addFavoritePerimeter$(
                this.pickedClassificationNodeLight.classificationId!,
                this.pickedClassificationNodeLight.classificationNodeId,
                this.pickedClassificationNodeLight.classificationNodeType
            );
        }
    }

    isSavePerimeterDisabled() {
        return this.pickedClassificationNodeLight?.classificationNodeId === ClassificationNodeId.ALL_BUILDINGS_NODE;
    }
}
